import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Box, Rating } from "@mui/material";
import Avatar from "./Avatar";

interface Review {
  reviewer_id: number;
  reviewer_first_name: string;
  reviewer_last_name: string;
  reviewer_role: string;
  reviewer_avatar_url: string;
  reviewer_city: string;
  reviewer_state: string;
  overall_score: number;
  comments: string;
  created_at: string;
}

interface ReviewsProps {
  baId: number;
}

const Reviews: React.FC<ReviewsProps> = ({ baId }) => {
  const [reviews, setReviews] = useState<Review[]>([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(
          `${
            import.meta.env.VITE_API_URL
          }/ambassadors/ambassadors/${baId}/reviews`
        );
        const data = await response.json();
        setReviews(data);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, [baId]);

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="h2" color="#6B20F5" gutterBottom>
          Reviews
        </Typography>
        {reviews.map((review) => (
          <Card key={review.reviewer_id} sx={{ mb: 2 }}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <Avatar
                  src={review.reviewer_avatar_url}
                  alt={`${review.reviewer_first_name} ${review.reviewer_last_name}`}
                  size={60}
                />
                <Box ml={2}>
                  <Typography variant="h6">
                    {review.reviewer_first_name} ({review.reviewer_city},{" "}
                    {review.reviewer_state})
                  </Typography>
                  <Typography variant="subtitle1" color="textPrimary">
                    {capitalizeFirstLetter(review.reviewer_role)}
                  </Typography>
                  <Rating
                    value={Number(review.overall_score)}
                    readOnly
                    precision={0.1}
                    sx={{
                      "& .MuiRating-iconFilled": {
                        color: "#6B20F5", // Change to your desired color
                      },
                      "& .MuiRating-iconEmpty": {
                        color: "#D1D7FF", // Change to your desired empty star color
                      },
                    }}
                  />
                </Box>
              </Box>
              <Typography variant="body1" paragraph>
                {review.comments}
              </Typography>
              <Typography variant="caption" color="textPrimary">
                {new Date(review.created_at).toLocaleDateString()}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  );
};

export default Reviews;
